<div class="container">
    <div class="row">
        <div class="pageTitle">Fiches pédagogiques</div>
    </div>

    <div class="sheetsContainer">
        @for (sheet of sheets; track sheet; let i = $index) {
        <div class="sheetContainer">
            <div
                (click)="openDoc(sheet)"
                class="sheetRow"
                [class.noMarginTop]="i === 0"
            >
                <i class="bi bi-file-earmark-pdf-fill"></i>
                <div class="fileName">{{ sheet.label }}</div>
            </div>
            @if (i < sheets.length - 1) {
            <div class="separator"></div>
            }
        </div>
        }
    </div>
</div>
